import { render, staticRenderFns } from "./FlashcardsPreview.vue?vue&type=template&id=2394bb96&scoped=true&"
import script from "./FlashcardsPreview.vue?vue&type=script&lang=js&"
export * from "./FlashcardsPreview.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardsPreview.vue?vue&type=style&index=0&id=2394bb96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394bb96",
  null
  
)

component.options.__file = "FlashcardsPreview.vue"
export default component.exports